<template>
  <v-container fluid>

    <PdfModal v-model="mostrarPdf" title="Vista"
      :file-name="`Recibo de pago correspondiente a la membresia ${this.MembresiaSelec}`"
      :fetch-document="obtenerPdf" />
    <PdfModal v-model="mostrarPdfFactura" title="Vista de" :file-name="`Factura ${this.idFactura}`"
      :file-type="this.tipoFactura" :fetch-document="obtenerPdfFactura" />
    <!-- <div class="text-h4 text-md-h4 text-lg-h4 gris--text">Listado recibos</div> -->
    <!-- <v-typography variant="h4">Busca recibos y aplica pagos.</v-typography> -->
    <v-card outlined class="cobranza-toolbar mb-3">
      <!-- Primera línea: periodo, acciones y resumen -->
      <v-row dense align="center" class="ma-0 px-3 pt-2 pb-1">
        <!-- Periodo -->
        <v-col cols="12" sm="4" md="3" lg="2">
          <div class="toolbar-campo">
            <span class="toolbar-label">
              Periodo
            </span>

            <YearPicker v-model="selectedYear" />
          </div>
        </v-col>

        <!-- Acciones -->
        <v-col cols="12" sm="5" md="4" lg="3" class="toolbar-acciones">
          <v-btn small color="azul_med" dark elevation="0" :loading="loading" :disabled="loading"
            @click="onClickFunction">
            <v-icon left small>
              mdi-magnify
            </v-icon>

            Consultar
          </v-btn>

          <v-btn small outlined color="azul_med" elevation="0" :disabled="loading || resumenPeriodo.total === 0"
            @click="Descargar">
            <v-icon left small>
              mdi-printer-outline
            </v-icon>

            Imprimir
          </v-btn>
        </v-col>

        <v-spacer />

        <!-- Resumen del periodo -->
        <v-col cols="12" sm="12" md="5" lg="4" class="d-flex justify-md-end">
          <div class="resumen-aplicados">
            <div class="resumen-encabezado">
              <div>
                <span class="resumen-label">
                  Recibos aplicados
                </span>

                <div class="resumen-principal">
                  <strong>{{ resumenPeriodo.pagados }}</strong>
                  <span>de {{ resumenPeriodo.total }}</span>
                </div>
              </div>

              <div class="resumen-porcentaje">
                {{ resumenPeriodo.porcentaje }}%
              </div>
            </div>

            <v-progress-linear :value="resumenPeriodo.porcentaje" height="5" rounded color="green"
              background-color="grey lighten-3" />

            <div class="resumen-pie">
              <span>
                {{ resumenPeriodo.impagos }}
                pendiente{{ resumenPeriodo.impagos === 1 ? '' : 's' }}
              </span>

              <span>
                {{ resumenPeriodo.total }} recibos del periodo
              </span>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider />

      <!-- Segunda línea: filtro y buscador -->
      <v-row dense align="center" class="ma-0 px-3 py-2">
        <!-- Estado -->
        <v-col cols="12" sm="4" md="4" lg="2">
          <v-select v-model="filtroPago" :items="opcionesFiltro" item-text="text" item-value="value" label="Estado"
            prepend-inner-icon="mdi-filter-outline" dense outlined hide-details />
        </v-col>

        <!-- Buscar -->
        <v-col cols="12" sm="8" md="6" lg="5">
          <v-text-field v-model.trim="search" label="Buscar titular, contratante, membresía o agente"
            prepend-inner-icon="mdi-magnify" clearable dense outlined hide-details />
        </v-col>

        <v-spacer />

        <!-- Resultados -->
        <v-col cols="12" sm="12" md="3" lg="3" class="resultados-tabla">
          <v-icon small color="azul_med" class="mr-1">
            mdi-calendar-month-outline
          </v-icon>

          <strong> {{ recibosVisibles.length }} </strong>

          recibo{{ recibosVisibles.length === 1 ? '' : 's' }}

          <span class="text--secondary">
            · {{ selectedYear }}
          </span>
        </v-col>
        
      </v-row>
    </v-card>
<div
  v-if="tipo === 'administrador'"
  class="totales-discretos"
>
  <span>
    Cobrado:
    <strong class="total-cobrado">
      {{ $formatCurrency(resumenPeriodo.totalCobrado) }}
    </strong>
  </span>

  <span class="total-separador">•</span>

  <span>
    Por cobrar:
    <strong class="total-pendiente">
      {{ $formatCurrency(resumenPeriodo.totalPorCobrar) }}
    </strong>
  </span>
</div>
    <div class="cont-bord-gris">
      <v-data-table :items="recibosVisibles" :loading="loading" loading-text="Cargando recibos..." :items-per-page="-1"
        hide-default-footer fixed-header height="calc(100vh - 245px)" calculate-widths :headers="headers" dense
        item-key="idpago" class="custom-data-table" :no-data-text="search
          ? 'No se encontraron recibos con esa búsqueda'
          : 'No hay recibos disponibles para este periodo'
          ">

        <template v-slot:item="{ item }">
          <tr @click="selectRow(item)" :class="{ 'selected-row': selectedRow && selectedRow === item.idpago }">

            <template>

              <td>
                <v-chip v-if="item.idpago" x-small color="blue-grey lighten-5" text-color="blue-grey darken-2"
                  class="agente-chip mt-1">
                  <span class="agente-chip-text">
                    {{ folioCorto(item.idpago) }}
                  </span>
                </v-chip>
              </td>
            </template>
            <template>
              <td class="persona-cell">
                <div class="dato-principal">
                  <span class="dato-valor">
                    {{ item.contratante || 'Sin contratante' }}
                  </span>
                </div>

                <div class="dato-secundario">
                  <v-icon x-small class="mr-1">
                    mdi-card-account-details-outline
                  </v-icon>

                  <span class="dato-label"></span>

                  <span class="membresia-texto">
                    {{ item.contrato }}
                  </span>
                </div>
              </td>
            </template>
            <td class="persona-cell">
              <div class="dato-fila">

                <span class="dato-valor">
                  {{ item.nombretitular || 'Sin titular' }}
                </span>
              </div>

              <div v-if="item.agente || item.Agente || item.NomAgente" class="dato-fila dato-fila-secundaria">
                <span class="dato-label">Ag.</span>

                <span class="dato-valor-secundario">
                  {{ item.agente }}
                </span>
              </div>
            </td>
            <template>
              <td>
                {{ item.DatePagoFormat || '-' }}
              </td>
            </template>
            <template>
              <td>
                <div>
                  <strong>{{ item.recibo }}</strong>
                  de
                  <strong>{{ item.recibos }}</strong>
                </div>

                <v-chip v-if="cantidadPendientesAnteriores(item) > 0" x-small color="orange lighten-4"
                  text-color="orange darken-4" class="mt-1" @click.stop="verPagos(item.contrato)">
                  <v-icon left x-small>mdi-history</v-icon>

                  {{ cantidadPendientesAnteriores(item) }}
                  pendiente{{ cantidadPendientesAnteriores(item) === 1 ? '' : 's' }}
                  <!-- anterior{{ cantidadPendientesAnteriores(item) === 1 ? '' : 'es' }} -->
                </v-chip>
              </td>
            </template>
            <template>
              <td>
                <template v-if="Number(item.pagado) === 0">
                  <span v-if="Number(item.Diferencia) > 5" class="retardo-critico">
                    <v-icon x-small color="red darken-2" class="mr-1">
                      mdi-alert-circle
                    </v-icon>

                    {{ item.Diferencia }} días
                  </span>

                  <span v-else-if="Number(item.Diferencia) > 1" class="retardo-advertencia">
                    {{ item.Diferencia }} días
                  </span>

                  <span v-else-if="Number(item.Diferencia) === 1" class="retardo-advertencia">
                    1 día
                  </span>

                  <span v-else-if="Number(item.Diferencia) === 0" class="vence-hoy">
                    Hoy
                  </span>

                  <span v-else class="a-tiempo">
                    A tiempo
                  </span>
                </template>

                <template v-else>
                  <v-btn v-if="item.Factura" icon small @click.stop="verFactura(item.Factura, 'pdf')">
                    <v-icon size="21" color="red">
                      mdi-file-pdf-box
                    </v-icon>
                  </v-btn>

                  <v-btn v-if="item.Factura" icon small @click.stop="verFactura(item.Factura, 'xml')">
                    <v-icon size="21" color="blue-grey">
                      mdi-xml
                    </v-icon>
                  </v-btn>

                  <v-btn v-if="!item.Factura && tipo === 'administrador'" text x-small color="primary" :disabled="facturandoId !== null"
                    @click.stop="facturarPago(item)">
                    <v-progress-circular v-if="facturandoId === item.idpago" indeterminate size="14" width="2"
                      class="mr-2" />

                    {{ facturandoId === item.idpago ? 'Espera...' : 'Facturar' }}
                  </v-btn>
                </template>
              </td>
            </template>
            <template>
              <td class="text-center" v-if="item.pagado === 0">
                IMPAGO
              </td>
              <td v-else dark class="elemento-pagado text-center">
                <strong>PAGADO</strong>
                <div class="small-chip">
                  {{ item.FormaPago }}
                </div>
              </td>
            </template>

            <template>
              <td>
                <span class="creado-style"> {{ item.FecPagoFormat }}</span>
              </td>
            </template>
            <template>
              <td class="text-end">
                <span class="estatus-activo">{{ $formatCurrency(item.pago) }}</span>
              </td>
            </template>
            <template>
              <v-menu offset-z left open-on-click close-on-content-click>
                <template v-slot:activator="{ on, attrs }">
                  <td><v-btn @click="selectRow(item)" :class="{
                    'pagado-row': Number(item.pagado) === 1,
                    'impago-row': Number(item.pagado) === 0,
                    'selected-row': selectedRow === item.idpago
                  }" red icon v-bind="attrs" v-on="on">
                      <v-icon size="28">mdi-dots-vertical-circle-outline</v-icon>
                    </v-btn></td>
                </template>
                <v-list>
                  <v-list-item  v-if="tipo === 'administrador'" :disabled="!(item.pagado == '0')" @click="openModalPago(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-cash-register</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> APLICA PAGO</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="VerReciboPagoPdf(item.idpago)">
                    <v-list-item-icon>
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> VER RECIBO</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="verPagos(item.contrato)">
                    <v-list-item-icon>
                      <v-icon>mdi-list-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> HISTORIAL DE RECIBOS</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="enviarCorreo(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-email-fast</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> ENVIAR RECIBO</v-list-item-title>
                  </v-list-item>

                </v-list>
              </v-menu>
            </template>
          </tr>
        </template>

      </v-data-table>
      <send-email-recibo-modal 
      :isOpen.sync="showModalSendRecibo" 
      :item="PagoSelect" 
      @close="closeModalSendPago" />

      <modal-list-pagos :isOpen.sync="isModLisPagos" :Membresia="this.MembresiaSelec || ''"></modal-list-pagos>

      <modal-pago :isOpen.sync="dialogPagoShow" :item="selectedPago" @save="aplicaPagoActiva"
        @close="dialogPagoShow = false"></modal-pago>

    </div>
  </v-container>
</template>
<script>
import PdfModal from "@/components/PdfModalComponent.vue";
import YearPicker from '@/components/selectAnioComponent.vue'
import SendEmailReciboModal from '@/components/modals/modalSendEmailReciboComponent.vue'
import ModalPago from '@/components/Pagos/modalAplicaPagoComponent.vue'
import ModalListPagos from '@/components/modals/ListPagoComponent.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'InicioAgente',
  props: {
    tipo: {
      type: String,
      default: ''
    }
  },
  components: {
    YearPicker,
    SendEmailReciboModal,
    ModalPago,
    ModalListPagos,
    PdfModal
  },
  watch: {
    "$route.params.mem"(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.search = newVal;
      }
    },
    selectedYear(val) {
      if (val) {
        this.Busqueda = null
      }
    }
  },
  computed: {
        ...mapGetters(['getCODAGE']),
    recibosPeriodo() {
      const pagos = Array.isArray(this.pagos)
        ? this.pagos
        : [];

      const periodo = String(
        this.selectedYear || this.obtenerPeriodoActual()
      ).slice(0, 7);

      return pagos.filter(item =>
        this.perteneceAlPeriodo(item, periodo)
      );
    },
    recibosVisibles() {
      let recibos = [...this.recibosPeriodo];

      // Filtro de estado
      if (this.filtroPago === 'pagados') {
        recibos = recibos.filter(
          item => Number(item.pagado) === 1
        );
      }

      if (this.filtroPago === 'pendientes') {
        recibos = recibos.filter(
          item => Number(item.pagado) === 0
        );
      }

      // Búsqueda local
      const termino = this.normalizarBusqueda(this.search);

      if (termino) {
        recibos = recibos.filter(item => {
          const agente =
            item.agente ||
            item.Agente ||
            item.NomAgente ||
            '';

          const campos = [
            item.idpago,
            item.contrato,
            item.contratante,
            item.nombretitular,
            agente,
            item.NomColectivo,
            item.DatePagoFormat,
            item.FecPagoFormat,
            item.FormaPago,
            item.recibo,
            item.recibos,
            item.pago
          ];

          return campos.some(campo =>
            this.normalizarBusqueda(campo).includes(termino)
          );
        });
      }

      return recibos.sort((a, b) => {
        const estadoA = Number(a.pagado);
        const estadoB = Number(b.pagado);

        // Primero los impagos
        if (estadoA !== estadoB) {
          return estadoA - estadoB;
        }

        // Después por fecha
        return (
          this.obtenerFechaRecibo(a) -
          this.obtenerFechaRecibo(b)
        );
      });
    },
    resumenPeriodo() {
      const recibos = Array.isArray(this.recibosPeriodo)
        ? this.recibosPeriodo
        : [];

      const recibosPagados = recibos.filter(
        item => Number(item.pagado) === 1
      );

      const recibosImpagos = recibos.filter(
        item => Number(item.pagado) === 0
      );

      const sumar = items =>
        items.reduce(
          (total, item) =>
            total + (Number(item.pago) || 0),
          0
        );

      const total = recibos.length;
      const pagados = recibosPagados.length;
      const impagos = recibosImpagos.length;

      return {
        total,
        pagados,
        impagos,

        totalCobrado: sumar(recibosPagados),
        totalPorCobrar: sumar(recibosImpagos),

        porcentaje: total > 0
          ? Math.round((pagados / total) * 100)
          : 0
      };
    },
    duplicateColors() {
      //const counts = {};
      const colors = {};

      // Conserva aquí tu implementación actual...
      return colors;
    }
  },
  mounted() {
    this.getPagosPendientes()
    this.search = this.$route.params.mem || null;
  },
  created() {
    //this.filtrarDatos(); // ✅ carga inicial con filtro "Todos"
  },
  data: () => ({
    facturandoId: null,
    mostrarPdfFactura: null,
    idFactura: null,
    tipoFactura: 'pdf',
    idPagoSelect: null,

    mostrarPdf: false,
    showModalSendRecibo: false,
    bucketFormatos: process.env.VUE_APP_BUCKETFORMATOS,
    dialogPagoShow: false,
    selectedPago: {},
    snackbar: true,
    vertical: true,
    selectedRow: null,
    PagoSelect:null,
    textAlert: '',
    NumRecibosSelec: null,
    MembresiaSelec: null,
    isModLisPagos: false,
    Busqueda: null,
    reciboSeleccionado: null,
    selectedYear: new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" }))
      .toISOString().slice(0, 7), search: '',
    pagos: [],
    expanded: [],
    total: 0,
    totalPagados: 0,
    totalPendientes: 0,
    headers: [
      { text: 'Folio', value: 'idpago', width: '125px', sortable: false },
      //{ text: 'Contrato', value: 'contrato', width: '10%', sortable: true },
      //{ text: "Contrato", value: "contrato", align: "d-none" }, // Columna oculta
      { text: 'Contratante', value: 'contratante', width: '15%', sortable: false },
      { text: 'Titular', value: 'nombretitular', width: '15%', sortable: false },
      //{ text: 'Agente', value: 'agente', sortable: true },
      { text: 'FechaPago', value: 'DatePagoFormat', width: '10%', sortable: true },
      { text: 'Recibo', value: 'recibo', width: '10%', sortable: false },
      { text: 'Retardo/factura', value: 'Diferencia', width: '10%', sortable: false },
      { text: 'Estatus', value: 'pagado', width: '10%', sortable: true },

      { text: 'Aplicado', value: 'FecPagoFormat', width: '10%', sortable: true },
      { text: 'Monto', value: 'pago', width: '5%', sortable: false, align: 'end' },
      { text: 'Opciones', value: 'ops', width: '5%', sortable: false, align: 'center' },
    ],
    loading: false,
    filtroPago: 'todos',

    opcionesFiltro: [
      {
        text: 'Todos los estados',
        value: 'todos'
      },
      {
        text: 'Pagados',
        value: 'pagados'
      },
      {
        text: 'Pendientes',
        value: 'pendientes'
      }
    ]
  }),
  methods: {
    normalizarBusqueda(valor) {
      return String(valor ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },

    normalizarNombre(nombre) {
      return String(nombre || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toUpperCase();
    },
    folioCorto(folio) {
      if (!folio) {
        return '-';
      }

      const valor = String(folio);

      if (valor.length <= 18) {
        return valor;
      }

      return `${valor.slice(0, 8)}…${valor.slice(-6)}`;
    },

    async copiarFolio(folio) {
      try {
        await navigator.clipboard.writeText(folio);

        this.$swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Folio copiado',
          showConfirmButton: false,
          timer: 1200,
          backdrop: false
        });
      } catch (error) {
        console.error('No se pudo copiar el folio', error);
      }
    },
    obtenerPeriodoActual() {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mexico_City',
        year: 'numeric',
        month: '2-digit'
      }).format(new Date()).slice(0, 7);
    },

    obtenerFechaRecibo(item) {
      /*
       * Utiliza primero DatePago porque normalmente viene como
       * fecha válida desde la API.
       */
      if (item.DatePago) {
        const fecha = new Date(item.DatePago);

        if (!Number.isNaN(fecha.getTime())) {
          return fecha;
        }
      }
      /*
       * Respaldo para fechas como 15-07-2026 o 15/07/2026.
       */
      if (item.DatePagoFormat) {
        const partes = item.DatePagoFormat
          .toString()
          .split(/[-/]/)
          .map(Number);

        if (partes.length === 3) {
          const [dia, mes, anio] = partes;
          return new Date(anio, mes - 1, dia);
        }
      }

      return new Date(0);
    },
    cantidadPendientesAnteriores(itemActual) {
      const fechaActual = this.obtenerFechaRecibo(itemActual);

      return this.pagos.filter(item => {
        return (
          item.contrato === itemActual.contrato &&
          Number(item.pagado) === 0 &&
          item.idpago !== itemActual.idpago &&
          this.obtenerFechaRecibo(item) < fechaActual
        );
      }).length;
    },
    perteneceAlPeriodo(item, periodo) {
      if (!periodo) {
        return true;
      }

      const fecha = this.obtenerFechaRecibo(item);

      if (fecha.getTime() === 0) {
        return false;
      }

      const anio = fecha.getFullYear();
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');

      return `${anio}-${mes}` === periodo;
    },

    verFactura(idfactura, tipo) {
      this.idFactura = idfactura
      this.tipoFactura = tipo
      this.mostrarPdfFactura = true
    },
    VerReciboPagoPdf(idrecibo) {
      this.idPagoSelect = idrecibo
      this.mostrarPdf = true
    },
    async obtenerPdf() {
      return await this.$http.get(`file/${this.idPagoSelect}/RECIBO_PAGO/pdf`,
        {
          responseType: 'blob'
        })
    },
    async obtenerPdfFactura() {
      return await this.$http.get(`file/VerFactura/${this.idFactura}/${this.tipoFactura}`,
        {
          responseType: 'blob'
        })
    },

    enviarCorreo(item) {
      this.PagoSelect = item
      this.PagoSelect.Email = item.Email
      this.PagoSelect.idpago = item.idpago
      
      this.showModalSendRecibo = true
    },
    closeModalSendPago(val) {
      this.showModalSendRecibo = val
    },
    getColor(contrato) {
      return this.duplicateColors[contrato] || "transparent"; // Si no es duplicado, fondo transparente
    },
    openModalPago(item) {
      this.selectedPago = { ...item };
      this.dialogPagoShow = true;
    },
    facturarPago(item) {
      // Evita doble clic o volver a facturar un recibo ya procesado
      if (this.facturandoId !== null || item.Factura) {
        return;
      }

      this.facturandoId = item.idpago;

      this.$http.post('Payment/UpdateFactura', {
        Folio: item.idpago,
        MetodoPago: ''
      })
        .then(response => {
          if (response.status === 200 && response.data) {
            item.Factura = response.data.factura;

            const index = this.pagos.findIndex(
              pago => pago.idpago === item.idpago
            );

            if (index !== -1) {
              this.$set(this.pagos, index, { ...item });
            }

            this.$swal.fire({
              toast: true,
              position: 'top-start',
              title: 'Correcto',
              text: response.data.message,
              icon: 'success',
              showConfirmButton: false,
              timer: 4000,
              backdrop: false
            });
          }
        })
        .catch(error => {
          const mensaje =
            error.response?.data ||
            'No se pudo facturar, intenta más tarde.';

          this.$swal.fire({
            position: 'center',
            html: mensaje,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            width: '400px',
            backdrop: false
          });
        })
        .finally(() => {
          this.facturandoId = null;
        });
    },
    aplicaPagoActiva(item) {
      this.$http.post('Payment', {
        Folio: item.idpago,
        MetodoPago: item.CodPago,
        Detalle: item.Referencia
      })
        .then(response => {
          if (response.status === 200) {
            const fechaHoy = new Date().toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).replace(/\//g, "-");

            if (response.data) {
              item.pagado = 1
              item.FecPagoFormat = fechaHoy
              item.Factura = response.data.factura;
              const index = this.pagos.findIndex(p => p.idpago === item.idpago);
              if (index !== -1) this.$set(this.pagos, index, { ...item });
              //this.$swal.fire.close();
              this.$swal.fire({
                toast: true,
                position: 'top-start',
                title: 'Correcto',
                text: response.data.message,
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: true,
                timer: 4000,
                width: '40%',  // Más ancho
                backdrop: false, // Evita que la alerta haga scroll al inicio
              })

            }
          }
          if (response.status === 409) {
            //this.$swal.fire.close()
            this.$swal.fire({
              position: 'center',
              // title: 'Valida',
              //text: 'Se genero un error',
              html: `No se puede aplicar el pago ya que </b> ${response.data}.`,
              icon: 'error',
              confirmButtonText: 'Cerrar',
              showCloseButton: true,
              showConfirmButton: true,
              //timer: 1500,
              width: '400px',
              backdrop: false, // Evita que la alerta haga scroll al inicio
            })
          }
        })
        .catch(() => {
          this.$swal.fire({
            position: 'center',
            // title: 'Valida',
            //text: 'Se genero un error',
            html: `Ocurrio un error, el cual ya fue reportado. intente mas tarde.`,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            //timer: 1500,
            width: '400px',
            backdrop: false, // Evita que la alerta haga scroll al inicio
          })
          this.dialogPagoShow = false
        })
        .finally(() => {
          this.dialogPagoShow = false
        });
    },
    registraPago(pago) {
      pago.pagado = 1
      const index = this.pagos.findIndex(p => p.idpago === pago.idpago);
      if (index !== -1) this.$set(this.pagos, index, { ...pago });
    },
    Descargar() {
      var urltarjet = `${process.env.VUE_APP_BUCKETFORMATOS}Pagos/reportePagos?qry=${this.selectedYear}`
      var newTab = window.open(urltarjet);
      if (newTab) {
        newTab.focus();
      }
    },
    selectRow(item) {
      this.selectedRow = item.idpago;
    },
    getRowClass(item) {
      return this.selectedRow && this.selectedRow === item.idpago ? 'selected-row' : '';
      //return item.pagado === 1 ? 'pagado-row' : 'impago-row';
    },
    verPagos(data) {
      this.MembresiaSelec = data
      this.isModLisPagos = true
    },
    onClickFunction() {
      if (this.$route.params.mem) {
        this.search = ''
      }
      this.getPagosPendientes()
    },
    verSoloPendientes() {
      this.selectedYear = null
      this.getPagosPendientes()
    },
    getPagosPendientes() {
      this.loading = true;

      // const url = this.selectedYear
      //   ? `{Cobranza}?qry=${this.selectedYear}`
      //   : 'getCobranza';

      let url;

  switch (this.tipo) {
    case 'agente':
      url = `Cobranza?qry=${this.selectedYear}&CodAge=${this.getCODAGE}`;
      break;

    case 'administrador':
            url = this.selectedYear
        ? `Cobranza?qry=${this.selectedYear}`
        : 'getCobranza';
      break;
    default:
      break;
  }

      this.$http
        .get(url)
        .then(response => {
          const datos = Array.isArray(response.data)
            ? response.data
            : [];

          this.pagos = datos.map(pago => ({
            ...pago,
            grupo: `${pago.contrato
              } - ${Number(pago.estado) === 1
                ? 'ACTIVA'
                : 'SUSPENDIDA'
              } - ${pago.NomColectivo || ''
              }`
          }));
        })
        .catch(error => {
          console.error(error);

          this.pagos = [];

          this.$swal.fire({
            position: 'center',
            html: 'Ha ocurrido un error inesperado, <b>intenta más tarde</b>.',
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    registrarPago(item) {
      this.PagoSelect.Membresia = item.contrato
      this.PagoSelect.PagoNum = item.recibo + ' de ' + item.recibos
      this.PagoSelect.Folio = item.idpago
    },
    onInputBusqueda(value) {
      this.selectedYear = null,
        this.Busqueda = value
    },
  }
}
</script>
<style scoped>
.creado-style {
  font-weight: bold;
  color: #696969;
  font-size: 12px;
}

.custom-data-table tbody tr.pagado-row>td {
  background-color: #e8f5e9 !important;
}

.custom-data-table tbody tr.impago-row>td {
  background-color: #fff8e1 !important;
}

.custom-data-table tbody tr.pagado-row:hover>td {
  background-color: #dcedc8 !important;
}

.custom-data-table tbody tr.impago-row:hover>td {
  background-color: #ffecb3 !important;
}

.custom-data-table tbody tr.selected-row>td {
  background-color: #a0d0f4 !important;
}

.custom-data-table .pagado-row {
  background-color: rgb(220, 239, 220) !important;
}

.custom-data-table .impago-row {
  background-color: rgb(255, 255, 25) !important;
}

.custom-data-table .older-row {
  background-color: #ffe4e1;
  /* Color para filas con edad > 30 */
}

.custom-data-table .younger-row {
  background-color: #e0ffff;
  /* Color para filas con edad <= 30 */
}

.custom-data-table tbody tr td {
  padding: 4px 8px !important;
  height: 32px;
}

.elemento-pagado {
  background-color: #C8E6C9;
}

.small-chip {
  font-size: 10px;
  color: #575757;
}

.selected-row {
  background-color: #a0d0f4 !important;
  /* Color de fondo para la fila seleccionada */
}

.retardo-critico {
  color: #c62828 !important;
  font-weight: 700;
}

.retardo-advertencia {
  color: #ef6c00 !important;
  font-weight: 600;
}

.vence-hoy {
  color: #f57f17 !important;
  font-weight: 700;
}

.a-tiempo {
  color: #558b2f !important;
  font-weight: 600;
}

.persona-cell {
  min-width: 210px;
  max-width: 270px;
  padding: 5px 8px !important;
  vertical-align: middle;
}

.dato-fila {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  line-height: 1.2;
}

.dato-fila-secundaria {
  margin-top: 4px;
}

.dato-label {
  flex: 0 0 auto;
  font-size: 9px;
  font-weight: 700;
  color: #78909c;
}

.dato-valor {
  min-width: 0;
  font-size: 10px;
  font-weight: 600;
  color: #37474f;
  line-height: 1.2;
}

.dato-valor-secundario {
  min-width: 0;
  font-size: 9px;
  font-weight: 500;
  color: #607d8b;
  line-height: 1.2;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cobranza-toolbar {
  border-radius: 10px;
  background-color: #ffffff;
  overflow: hidden;
}

.toolbar-campo {
  max-width: 190px;
}

.toolbar-label {
  display: block;
  margin-bottom: 1px;
  font-size: 9px;
  font-weight: 700;
  color: #78909c;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.toolbar-acciones {
  display: flex;
  align-items: center;
  gap: 7px;
}

.resumen-aplicados {
  width: 100%;
  max-width: 250px;
  padding: 6px 10px;
  border: 1px solid #e8ecef;
  border-radius: 8px;
  background-color: #fafcfd;
}

.resumen-encabezado {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.resumen-label {
  display: block;
  font-size: 9px;
  font-weight: 600;
  color: #78909c;
}

.resumen-principal {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 1px;
  color: #455a64;
}

.resumen-principal strong {
  font-size: 16px;
  color: #2e7d32;
}

.resumen-principal span {
  font-size: 10px;
}

.resumen-porcentaje {
  font-size: 14px;
  font-weight: 700;
  color: #2e7d32;
}

.resumen-pie {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 9px;
  color: #78909c;
}

.resumen-pie span:first-child {
  color: #c62828;
  font-weight: 600;
}

.resultados-tabla {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 11px;
  color: #455a64;
}

@media (max-width: 959px) {
  .toolbar-campo {
    max-width: 100%;
  }

  .resumen-aplicados {
    max-width: 100%;
    margin-top: 4px;
  }

  .resultados-tabla {
    justify-content: flex-start;
    margin-top: 4px;
  }
}

@media (max-width: 599px) {
  .toolbar-acciones {
    margin-top: 4px;
  }

  .toolbar-acciones .v-btn {
    flex: 1;
  }

  .resumen-pie {
    flex-direction: column;
    gap: 2px;
  }
}
</style>